import { useTranslation } from 'react-i18next'
import { Alert, AlertDescription } from '@/components/ui/alert'

const PlanReadonlyAccessAlert = () => {
  const { t } = useTranslation()

  return (
    <Alert variant='info' className='py-2 w-fit'>
      <AlertDescription>
        {t('dashboard.team.plans.readonly-admin-access')}
      </AlertDescription>
    </Alert>
  )
}

export default PlanReadonlyAccessAlert
